import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { unsubscribeNewsletter } from '../../api/subscriberApi';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import LanguageContext from '../../context/LanguageContext';
import './Unsubscribe.css';
import Button from '../../components/UI/Button/Button';

const Unsubscribe = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const emailParam = searchParams.get('email');
        if (emailParam) {
            setEmail(emailParam);
        }
    }, [searchParams]);

    const handleUnsubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;

        setStatus('loading');
        setMessage('');

        try {
            const result = await unsubscribeNewsletter(email);
            setStatus('success');
            setMessage(result.message || t('unsubscribe.success'));
        } catch (error) {
            setStatus('error');
            setMessage(error.message || t('unsubscribe.error'));
        }
    };

    return (
        <main className="main">
            <Breadcrumb title={t('unsubscribe.title')} />

            <section className="unsubscribe-page">
                <div className="container unsubscribe-body" dir={dir()}>
                    <div className="unsubscribe-card">
                        {status === 'success' ? (
                            <div className="unsubscribe-result unsubscribe-result--success">
                                <div className="unsubscribe-success-visual" aria-hidden="true">
                                    <span className="unsubscribe-success-icon">&#10003;</span>
                                </div>
                                <h2 className="unsubscribe-title">{t('unsubscribe.doneTitle')}</h2>
                                <p className="unsubscribe-lead">{message}</p>
                            </div>
                        ) : (
                            <>
                                <p className="unsubscribe-lead">{t('unsubscribe.description')}</p>

                                <form className="unsubscribe-form" onSubmit={handleUnsubscribe} noValidate>
                                    <div className="unsubscribe-field">
                                        <label className="unsubscribe-label" htmlFor="unsub-email">
                                            {t('profilePage.email')}
                                        </label>
                                        <input
                                            id="unsub-email"
                                            type="email"
                                            className="unsubscribe-input"
                                            placeholder={t('unsubscribe.emailPlaceholder')}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            disabled={status === 'loading'}
                                            autoComplete="email"
                                        />
                                    </div>
                                    <Button
                                        type="submit"
                                        className="unsubscribe-submit"
                                        disabled={status === 'loading' || !email.trim()}
                                    >
                                        {status === 'loading'
                                            ? t('unsubscribe.processing')
                                            : t('unsubscribe.confirm')}
                                    </Button>
                                </form>

                                {status === 'error' && (
                                    <p className="unsubscribe-alert" role="alert">
                                        {message}
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Unsubscribe;
